'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { Record } from 'immutable';
import { EventTypes } from '../../lib/Constants';
import I18n from 'I18n';
export const EventColumns = {
  NAME: 'name',
  TOGGLE: 'toggle',
  TYPE: 'type',
  EVENT_TRIGGER_TYPE: 'eventTriggerType',
  EVENTS_SYNCED: 'numberReceived',
  AD_ACCOUNT: 'adAccount'
};
export const EventSyncErrorReasons = {
  NETWORK_EVENT_SET_NOT_FOUND: 'NETWORK_EVENT_SET_NOT_FOUND',
  UNKNOWN: 'UNKNOWN',
  PARTIAL_UPLOAD_FAILURE: 'PARTIAL_UPLOAD_FAILURE',
  NETWORK_ERROR_RESPONSE_READ_FAILURE: 'NETWORK_ERROR_RESPONSE_READ_FAILURE',
  UNPARSEABLE_CLICK_ID: 'UNPARSEABLE_CLICK_ID',
  INVALID_CONVERSION_TYPE: 'INVALID_CONVERSION_TYPE',
  PERMISSIONS_ISSUE: 'PERMISSIONS_ISSUE',
  INVALID_TIMING: 'INVALID_TIMING',
  UPLOADED_TOO_SOON: 'UPLOADED_TOO_SOON',
  USER_NOT_AUTHORIZED_FOR_OFFLINE_CONVERSIONS: 'USER_NOT_AUTHORIZED_FOR_OFFLINE_CONVERSIONS',
  TERMS_OF_SERVICE_NOT_ACCEPTED: 'TERMS_OF_SERVICE_NOT_ACCEPTED',
  EXPECTED_CROSS_ACCOUNT_CONVERSION_TRACKING_ON: 'EXPECTED_CROSS_ACCOUNT_CONVERSION_TRACKING_ON',
  EXPECTED_CROSS_ACCOUNT_CONVERSION_TRACKING_OFF: 'EXPECTED_CROSS_ACCOUNT_CONVERSION_TRACKING_OFF',
  EXPECTED_DIFFERENT_MCC_ID: 'EXPECTED_DIFFERENT_MCC_ID',
  CONFLICTING_MCC_IDS: 'CONFLICTING_MCC_IDS'
};
const USER_FACING_ERRORS = [EventSyncErrorReasons.NETWORK_EVENT_SET_NOT_FOUND, EventSyncErrorReasons.UNKNOWN, EventSyncErrorReasons.USER_NOT_AUTHORIZED_FOR_OFFLINE_CONVERSIONS, EventSyncErrorReasons.TERMS_OF_SERVICE_NOT_ACCEPTED, EventSyncErrorReasons.EXPECTED_CROSS_ACCOUNT_CONVERSION_TRACKING_ON, EventSyncErrorReasons.EXPECTED_CROSS_ACCOUNT_CONVERSION_TRACKING_OFF, EventSyncErrorReasons.EXPECTED_DIFFERENT_MCC_ID, EventSyncErrorReasons.CONFLICTING_MCC_IDS];
export const EventStatusType = {
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED',
  ERROR: 'ERROR'
}; // For legacy use until we ungate all to custom LCS

export const DEFAULT_STAGE_ID_EVENT_NAMES = {
  subscriber: 'SUBSCRIBER',
  lead: 'LEAD',
  marketingqualifiedlead: 'MARKETING_QUALIFIED_LEAD',
  salesqualifiedlead: 'SALES_QUALIFIED_LEAD',
  opportunity: 'OPPORTUNITY',
  customer: 'CUSTOMER',
  evangelist: 'EVANGELIST',
  other: 'OTHER'
};
const EVENT_NAME_DEFAULT_STAGE_IDS = Object.keys(DEFAULT_STAGE_ID_EVENT_NAMES).reduce((prev, stageId) => Object.assign({}, prev, {
  [DEFAULT_STAGE_ID_EVENT_NAMES[stageId]]: stageId
}), {});
export default class EventRecord extends Record({
  portalId: null,
  adNetwork: null,
  accountId: null,
  eventType: null,
  eventTriggerType: null,
  eventName: null,
  stageId: null,
  hubSpotFormId: null,
  eventCategory: null,
  setId: null,
  value: null,
  enabled: null,
  currencyCode: null,
  isOfflineEvent: null,
  isEstimatedValue: null,
  createdAt: null,
  numberSent: null,
  numberReceived: null,
  id: null,
  installedPixelId: null,
  eventSyncErrorReason: null,
  eventSyncErrorMessage: null,
  lastSyncedAt: null,
  deleted: false,
  consentContactPropertyName: null,
  consentContactPropertyValue: null,
  eventContactDataOptions: null,
  allowEventStreamingForContactsWithoutAdInteraction: null
}) {
  constructor(_ref) {
    let {
      eventType,
      lifecycleStageId
    } = _ref,
        props = _objectWithoutPropertiesLoose(_ref, ["eventType", "lifecycleStageId"]);

    super(Object.assign({
      eventType: eventType || DEFAULT_STAGE_ID_EVENT_NAMES[lifecycleStageId],
      stageId: lifecycleStageId || EVENT_NAME_DEFAULT_STAGE_IDS[eventType]
    }, props));
  }

  get type() {
    return this.isOfflineEvent ? EventTypes.CRM_EVENT : null;
  }

  get status() {
    if (!this.enabled) {
      return EventStatusType.PAUSED;
    }

    if (USER_FACING_ERRORS.includes(this.eventSyncErrorReason)) {
      return EventStatusType.ERROR;
    }

    return EventStatusType.ACTIVE;
  }

  renderColumn(column, adAccounts) {
    switch (column) {
      case EventColumns.NAME:
        return this.eventName;

      case EventColumns.EVENT_TRIGGER_TYPE:
        return I18n.text(`events.table.eventTriggers.${this.eventTriggerType}`);

      case EventColumns.EVENTS_SYNCED:
        return I18n.formatNumber(this.numberReceived);

      case EventColumns.AD_ACCOUNT:
        {
          const adAccount = adAccounts.find(account => account.network === this.adNetwork && account.accountId === this.accountId);
          return adAccount ? adAccount.getShortName() : '';
        }

      default:
        return null;
    }
  }

}